const YOUTUBE_API_SRC = "https://www.youtube.com/iframe_api";

let youtubeApiPromise = null;

/** Loads the YouTube IFrame API once and shares it between every player. */
export function loadYouTubeApi() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("YouTube API needs a browser"));
  }
  if (window.YT?.Player) {
    return Promise.resolve(window.YT);
  }
  if (!youtubeApiPromise) {
    youtubeApiPromise = new Promise((resolve, reject) => {
      const previousReadyHandler = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        previousReadyHandler?.();
        resolve(window.YT);
      };
      const script = document.createElement("script");
      script.src = YOUTUBE_API_SRC;
      script.async = true;
      script.onerror = () => {
        youtubeApiPromise = null;
        script.remove();
        reject(new Error("Could not load the YouTube IFrame API"));
      };
      document.head.appendChild(script);
    });
  }
  return youtubeApiPromise;
}
